import {BrowserModule} from '@angular/platform-browser';
import {NgModule, LOCALE_ID} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe, 'de-DE');

import {FiegerCalculatorCoreModule} from "../../projects/fieger-calculator-core/src/lib/fieger-calculator-core.module";

import {AppComponent} from './app.component';

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		FiegerCalculatorCoreModule
	],
	providers: [
		
		],
	bootstrap: [AppComponent]
})
export class AppModule {
}
